import { ListView } from "@progress/kendo-react-listview";
import {
  columnsConstructorSessionData,
  editedPropertyValues,
  items,
  propertiesVisible,
  propertiesWithHeaders,
  selectedColumnFieldPropertyValues,
  selectedColumnId,
} from "./ColumnsConstructorSignals";

const ItemRender = ({ props }) => {
  const handlePropertyChange = ({ propName, propValue }) => {
    editedPropertyValues.value = {
      ...editedPropertyValues.value,
      [selectedColumnId.value]: {
        ...editedPropertyValues.value[selectedColumnId.value],
        [propName]: propValue,
      },
    };
  };

  if (props.dataItem.id === 0) {
    return props.dataItem.renderer();
  }
  if (!propertiesVisible.value) {
    return;
  }
  if (props.dataItem.isHeader) {
    return props.dataItem.renderer();
  }

  return (
    <div className="align-rows">
      {props.dataItem.propertyDisplay}:
      {props.dataItem.renderer({
        handlePropertyChange,
        isTableEditor: true,
        currentPropertyValues: {
          ...selectedColumnFieldPropertyValues.value,
          ...editedPropertyValues.value?.[selectedColumnId.value],
        },
        fieldType: columnsConstructorSessionData.value.find(
          (col) => col.id === selectedColumnId.value
        )?.fieldType,
        galleryFields: columnsConstructorSessionData.value.map(({ fieldName, fieldType }) => ({
          text: fieldName,
          math: "Columns",
          expressionText: fieldName?.replace(/\s/g, ""),
          fieldType: fieldType,
        })),
      })}
    </div>
  );
};

export const ColumnsConstructorPropertyPane = () => {
  return (
    <div className="gallery-constructor-drawer">
      <ListView
        style={{
          backgroundColor: "var(--atlas-bg-primary)",
          borderBottomRightRadius: "20px",
          overflowY: "auto",
        }}
        className={"gallery-constructor-drawer"}
        data={[...items.value, ...propertiesWithHeaders.value]}
        item={(props) => ItemRender({ props })}
      />
    </div>
  );
};

export default ColumnsConstructorPropertyPane;
